/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Race_Read_WpmInputs */

const en_funnel_ob_race_read_wpm = /** @type {(inputs: Funnel_Ob_Race_Read_WpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~250 wpm`)
};

const es_funnel_ob_race_read_wpm = /** @type {(inputs: Funnel_Ob_Race_Read_WpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`~250 ppm`)
};

/**
* | output |
* | --- |
* | "~250 wpm" |
*
* @param {Funnel_Ob_Race_Read_WpmInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_race_read_wpm = /** @type {((inputs?: Funnel_Ob_Race_Read_WpmInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Race_Read_WpmInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_race_read_wpm(inputs)
	return en_funnel_ob_race_read_wpm(inputs)
});